import '../../App.css';
import React from 'react';
import TitleSection from './TitleSection/TitleSection';
import TableSection from './TableSection/TableSection';

class Security extends React.Component {

    render() {
        return (
            <div className="p-3 bg-white" id="appContent" style={{ width: '100%', height: '100%' }}>
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <div className="mb-2 d-sm-block d-md-flex justify-content-between align-items-center">
                        <TitleSection />
                    </div>
                    <TableSection />
                </div>
            </div>
        )
    }
}

export default Security;